// extracted by mini-css-extract-plugin
export default {"button":"PlatbackRateButton_button__mFMcr"};